<template>
  <div>
  </div>
</template>

<script>
import { callback, logout, afterCallback } from "@/api/auth";
import { setErrorMessage } from "@/utils/error";
import Raven from "raven-js";
import {
  getCampaignCautions,
  getCampaignId,
  getCodeVerifier,
  getPrize,
  removeCampaignCautions,
  removePrize,
  removeState,
  setCampaignCautions,
  setIsRetry,
  setLinkShare,
  setPrize,
  setState,
  getState,
  getCampaignImageContents,
  getCampaignContents,
  removeCampaignContents,
  removeCampaignImageContents,
  setCampaignId, removeCampaignId
} from "@/utils/campaign";
import {
  getAuthenResponse,
  getLogged,
  removeAuthenResponse,
  removeLogged,
  removeUserId,
  setAuthenResponse,
  setLogged,
  setTwitterToken,
  setUserId,
  setUserInfo,
  getTwitterToken,
  getUserAgentMobile,
  getUserId,
  removeTwitterToken,
  getUserInfo,
  removeUserInfo,
  removeUserAgentMobile,
  setUserAgentMobile
} from "@/utils/auth";

import store from "../store/index";

export default {
  async created() {
    store.dispatch("setLoading", true);
    try {
      // console.log(this.$route.query);
      let info = {
        'state': this.$route.query.state,
        'code': this.$route.query.code,
        'code_verifier': getCodeVerifier(),
      };
      Raven.setExtraContext({
        codeVerifier: getCodeVerifier()
      });
      Raven.captureMessage("authen/getCodeVerifier", {
        tags: { category: "test" },
        level: "info",
      });
      await callback(info)
        .then((response) => {

          // console.log(JSON.stringify(response));

          // Remove & Set twitter token from cookies
          if (getTwitterToken()) {
            removeTwitterToken();
          }
          setTwitterToken({
            access_token: JSON.stringify(response.result.user.token),
            secret: JSON.stringify(response.result.user.tokenSecret)
          })

          if (getCampaignId()) {
            removeCampaignId();
          }
          setCampaignId(response.result.campaignId);

          if (getUserAgentMobile()) {
            removeUserAgentMobile();
          }
          setUserAgentMobile(response.result.userAgentMobile);

          // Remove token from cookies
          if (getLogged()) {
            logout();
            removeLogged();
          }

          // Remove campaign state from cookies
          if (getState()) {
            removeState();
          }

          // Remove authen response from cookies
          if (getAuthenResponse()) {
            removeAuthenResponse();
          }

          // remove prize from cookies if available
          if (getPrize()) {
            removePrize();
          }

          // remove campaign cautions from cookies if available
          if (getCampaignCautions()) {
            removeCampaignCautions();
          }

          // Remove user id from cookies
          if (getUserId()) {
            removeUserId();
          }

          // Remove user info from cookies
          if (getUserInfo()) {
            removeUserInfo();
          }

          // Remove campaign contents from cookies
          if (getCampaignContents()) {
            removeCampaignContents();
          }

          // Remove campaign image contents from cookies
          if (getCampaignImageContents()) {
            removeCampaignImageContents();
          }

          // The signed-in user info.
          if (getTwitterToken()) {
            let info = {
              'sns_auth_id': response.result.user.id,
              'name': response.result.user.name,
              'email': response.result.user.email,
              'campaign_id': getCampaignId(),
              'user_agent_mobile': getUserAgentMobile(),
              'access_token': response.result.user.token,
              'secret': response.result.user.tokenSecret
            }
            // console.log(JSON.stringify(info));

            // Set current user info to cookies
            setUserInfo({
              name: response.result.user.name,
              image_url: response.result.user.avatar,
            });

            afterCallback(info)
              .then((data) => {
                // console.log(JSON.stringify(data));
                // Set retry status
                setIsRetry(0);

                if (data.status === 'success') {
                  // set token to cookies
                  if (data.result.token) {
                    setLogged(data.result.token)
                  }
                  // Set user id to cookies
                  setUserId(data.result.user.id);

                  // set state to not-play
                  setState("not-play")

                  // Set link to share
                  setLinkShare(data.result.link_share_line);

                  // next('/main');
                  this.$router.push("/main");
                } else if (data.status === 'campaign_end') {
                  // set campaign cautions to cookies
                  setCampaignCautions(data.result.caution)

                  this.$router.push('/campaign-ended');
                } else if (data.status === 'is_entry') {

                  // Set user id to cookies
                  if (data.result.user_id) {
                    setUserId(data.result.user_id);
                  }

                  // check if campaign win and save to cookies and go to /prize
                  if (data.result.prizes) {
                    let prize = {
                      'campaign_name': data.result ? data.result.campaign_name : "",
                      'name': data.result.prizes ? data.result.prizes.name : "",
                      'imageUrl': data.result.prizes.image_of_prize,
                      'type': data.result.prizes ? data.result.prizes.type : 0,
                      'date': data.result.prizes ? data.result.application_date : "",
                      'google_form': data.result.prizes ? data.result.prizes.google_form_url : null,
                      'code': data.result.prizecodes ? data.result.prizecodes.code : null,
                      'externalUrl': data.result.prizes ? data.result.prizes.external_url : ""
                    }
                    // set prize to cookies
                    setPrize(prize);

                    // set state to win-physical or win-digital
                    if (data.result.prizecodes) {
                      setState("win-digital")
                    } else {
                      setState("win-physical")
                    }

                    this.$router.push('/prize');
                  } else {
                    // set token to cookies
                    if (data.result.token) {
                      setLogged(data.result.token)
                    }

                    // set userId to cookies
                    if (data.result.user_id) {
                      setUserId(data.result.user_id);
                    }

                    // set state to lose-not-retry
                    setState("lose-not-retry")

                    // Set link to share
                    setLinkShare(data.result.link_share_line);
                    // console.log('share url:',getLinkShare());

                    this.$router.push('/joined-campaign');
                  }
                } else if (data.status === 'is_retry') {
                  // set campaign cautions to cookies
                  setCampaignCautions(data.result.caution)

                  // set userId to cookies
                  if (data.result.user_id) {
                    setUserId(data.result.user_id);
                  }

                  // set state to lose-not-retry
                  setState("lose-retried")

                  this.$router.push('/retried-campaign');
                } else if (data.status === 'not_follow' ||
                  data.status === 'not_retweet' || data.status === 'not_retweet_follow') {
                  // set authen response to cookies
                  setAuthenResponse(data);

                  this.$router.push('/insufficient-conditions');
                }
              })
              .catch(error => {
                if (error.response && error.response.status) {
                  setErrorMessage(error.response.status);
                }
                Raven.setExtraContext({
                  error: error.response,
                  sns_auth_id: info.sns_auth_id,
                  name: info.name,
                  email: info.email,
                  campaign_id: info.campaign_id,
                });
                Raven.captureMessage("callback/afterCallback api error", {
                  tags: { category: "test" },
                  level: "error",
                });
                this.$router.push('/not-found');
              });
          } else {
            Raven.setExtraContext({
              state: info.state,
            });
            Raven.captureMessage("callback/callback error", {
              tags: { category: "test" },
              level: "error",
            });
            this.$router.push('/not-found');
          }
        });
    } catch (error) {
      Raven.captureMessage("callback/info set error", {
        tags: { category: "test" },
        level: "error",
      });
      console.log(error)
      this.$router.push('/not-found');
    }
  }
}
</script>